"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.afto781V1DataSchema = exports.afto781V1DataCertificationSchema = exports.afto781V1DataARMSAuditSchema = exports.afto781V1DataARMSInputSchema = void 0;
const yup = __importStar(require("yup"));
const afto_781_v1_mission_data_1 = require("./afto_781_v1-mission-data");
const afto_781_v1_aircrew_data_1 = require("./afto_781_v1-aircrew-data");
exports.afto781V1DataARMSInputSchema = yup.object().shape({
    date: yup.number().nullable().optional(),
    initials: yup.string().nullable().optional(),
});
exports.afto781V1DataARMSAuditSchema = yup.object().shape({
    date: yup.number().nullable().optional(),
    initials: yup.string().nullable().optional(),
});
exports.afto781V1DataCertificationSchema = yup.object().shape({
    printedName: yup.string().nullable().optional(),
    rank: yup.string().nullable().optional(),
    branchOfService: yup.string().nullable().optional(),
    dsn: yup.string().nullable().optional(),
    signature: yup.string().nullable().optional(),
});
exports.afto781V1DataSchema = yup.object().shape({
    aircraftId: yup.string().nullable().optional(),
    missionData: yup.array().of(afto_781_v1_mission_data_1.afto781V1MissionDataSchema).nullable().optional(),
    flightAuth: yup.string().nullable().optional(),
    issuingUnit: yup.string().nullable().optional(),
    aircrewData: yup.array().of(afto_781_v1_aircrew_data_1.afto781V1AircrewDataSchema).nullable().optional(),
    maintReview: yup.string().nullable().optional(),
    pilotReview: yup.array().of(yup.string().nullable().optional()).nullable().optional(),
    sarmReview: yup.string().nullable().optional(),
    armsInput: exports.afto781V1DataARMSInputSchema.nullable().optional(),
    armsAudit: exports.afto781V1DataARMSAuditSchema.nullable().optional(),
    certification: exports.afto781V1DataCertificationSchema.nullable().optional(),
    remarks: yup.string().nullable().optional(),
});
